import { jsx as r } from "react/jsx-runtime";
import { createContext as u, useMemo as c, useContext as x } from "react";
import * as o from "@radix-ui/react-avatar";
import { twMerge as n } from "tailwind-merge";
const l = u({
  size: "md"
}), d = ({ size: e = "md", children: t, className: s, ...a }) => {
  const i = c(() => ({ size: e }), [e]), m = c(() => {
    switch (e) {
      case "2xs":
        return "size-6";
      case "xs":
        return "size-8";
      case "sm":
        return "size-10";
      case "md":
        return "size-12";
      case "lg":
        return "size-16";
      case "xl":
        return "size-24";
    }
  }, [e]);
  return /* @__PURE__ */ r(l.Provider, { value: i, children: /* @__PURE__ */ r(
    o.Root,
    {
      className: n(
        "flex select-none items-center justify-center overflow-hidden rounded-full bg-gray-200",
        m,
        s
      ),
      ...a,
      children: t
    }
  ) });
}, f = ({ className: e, ...t }) => /* @__PURE__ */ r(
  o.Image,
  {
    className: n("size-full border-inherit object-cover", e),
    ...t
  }
), v = ({
  className: e,
  ...t
}) => {
  const { size: s } = x(l), a = c(() => {
    switch (s) {
      case "2xs":
        return "text-[10px]";
      case "xs":
      case "sm":
        return "text-xs";
      case "md":
      case "lg":
        return "text-base";
      case "xl":
        return "text-2xl";
    }
  }, [s]);
  return /* @__PURE__ */ r(
    o.Fallback,
    {
      className: n(
        "flex size-full items-center justify-center rounded-full font-medium leading-3",
        a,
        e
      ),
      role: "img",
      ...t
    }
  );
}, g = d, z = v, p = g, C = f, j = z;
export {
  g as Avatar,
  z as AvatarFallback,
  f as AvatarImage,
  j as Fallback,
  C as Image,
  p as Root
};
